export default {
  data: function() {
    const defaultFilters = {
      sortOrder: "",
      selectedAirlines: [],
      unusedTicketsOnly: false,
      minPrice: this.minPrice ?? 0,
      maxPrice: this.maxPrice ?? 5000,
      minPolicy: "",
      minRating: "",
      maxStopsSegment1: "",
      maxStopsSegment2: "",
      timeRangeSegment1: { segment: 0, range: [0, 24] },
      timeRangeSegment2: { segment: 0, range: [0, 24] },
      ndc: "",
    };

    return {
      //make a deep clone to initalize filter object to default values
      filters: JSON.parse(JSON.stringify(defaultFilters)),

      //clone a second object to keep original default values (for highlight function)
      defaultFilterValues: JSON.parse(JSON.stringify(defaultFilters)),
    };
  },
  computed: {
    //show blue highlights whenever filter value has changed from default value
    highlightedFilters() {
      return {
        sorting: false,
        airline: this.filters.selectedAirlines > 0 || false,
        policy:
          this.filters.minPolicy !== this.defaultFilterValues.minPolicy ||
          false,
        rating:
          this.filters.minRating !== this.defaultFilterValues.minRating ||
          false,
        times: this.highlightTimes || false,
        stops:
          this.filters.maxStopsSegment1 !==
            this.defaultFilterValues.maxStopsSegment1 ||
          this.filters.maxStopsSegment2 !==
            this.defaultFilterValues.maxStopsSegment2 ||
          false,
        price: this.highlightPrice || false,
        unusedTickets:
          this.filters.unusedTicketsOnly !==
            this.defaultFilterValues.unusedTicketsOnly || false,
        ndc: this.filters.ndc !== "",
      };
    },

    highlightTimes() {
      return this.filters.timeRangeSegment1.range[0] !== 0 ||
        this.filters.timeRangeSegment1.range[1] !== 24 ||
        this.filters.timeRangeSegment2.range[0] !== 0 ||
        this.filters.timeRangeSegment2.range[1] !== 24
        ? true
        : false;
    },

    highlightPrice() {
      return this.minPrice !== this.filters.minPrice ||
        this.maxPrice !== this.filters.maxPrice
        ? true
        : false;
    },

    //Get all flight prices for price options slider
    priceData() {
      {
        let data = [];
        if (this.items) {
          data = this.items.map((x) => x.pricing.total);
          data.sort((a, b) => a - b);
        }
        return data;
      }
    },

    minPrice() {
      return this.priceData[0].toFixed(0);
    },

    maxPrice() {
      return this.priceData[this.priceData.length - 1].toFixed(0);
    },
  },
  methods: {
    defaultFilters(showRestoreMessage = true) {
      if (showRestoreMessage) {
        this.$buefy.toast.open({
          message: "Please wait while we're restoring defaults",
          type: "is-info",
        });
      }

      //reset each filter to default value
      let names = Object.keys(this.filters);
      names.forEach((name) => {
        this.filters[name] = this.defaultFilterValues[name];
      });

      this.filters.minPrice = this.minPrice;
      this.filters.maxPrice = this.maxPrice;
    },

    resetFilter(value) {
      // console.log('resetFilter: filterType', value);
      switch (value) {
        case "sortOrder":
        case "minPolicy":
        case "minRating":
        case "maxStopsSegment1":
        case "maxStopsSegment2":
          this.filters[value] = "";
          break;
        case "unusedTicketsOnly":
          this.filters.unusedTicketsOnly = false;
          break;
        case "selectedAirlines":
          this.filters.selectedAirlines = [];
          break;
        case "priceRange":
          this.filters.minPrice = this.minPrice;
          this.filters.maxPrice = this.maxPrice;
          break;
        case "timeRangeSegment1":
          this.filters.timeRangeSegment1 = { segment: 0, range: [0, 24] };
          break;
        case "timeRangeSegment2":
          var tempSegment2 = this.tripVal === 1 ? [0, 24] : ["", ""];
          this.filters.timeRangeSegment2 = { segment: 0, range: tempSegment2 };
          break;
        case "ndc":
          this.filters.ndc = "";
          break;
        default:
          this.defaultFilters();
      }
    },

    getPriceRange(items) {
      let range = [];

      if (items) {
        if (items.length) {
          range = [items[0].pricing.total, items[0].pricing.total];
          for (let i = 1; i < items.length; i++) {
            var price = items[i].pricing.total;
            if (price < range[0]) {
              range[0] = price;
            } else if (price > range[1]) {
              range[1] = price;
            }
          }
          // range[0] = Math.round(range[0] / 100)
          // range[1] = Math.round(range[1] / 100)
        }
      }

      //console.log('range', range);
      return range;
    },

    /*
    getAirlines(items) {
      let carriersList = [];
      let vendors = this.$globals.vendors;
      if (items) {
        for (let i = 0; i < items.length; i++) {
          var carrier;
          carrier = items[i].journeys[0].airlineCode;
          if (!carriersList.includes(carrier) && carrier != "") {
            carriersList.push(carrier);
          }
        }
      }
      return carriersList.sort(function(a, b) {
        if (vendors.airlines[a] < vendors.airlines[b]) {
          return -1;
        } else {
          return 1;
        }
      });
    },

    getLegs(journey, items) {
      let legs = 3;

      if (items) {
        if (items.length) {
          for (let i = 0; i < items.length; i++) {
            if (legs > items[i].journeys[journey].legs.length) {
              legs = items[i].journeys[journey].legs.length;
            }
          }
        }
      }
      return legs;
    },
    getStops(journey, items) {
      let stops = 2;
      if (items) {
        if (items.length) {
          for (let i = 0; i < items.length; i++) {
            if (stops > items[i].journeys[journey].legs.length - 1) {
              stops = items[i].journeys[journey].legs.length - 1;
            }
          }
        }
      }
      return stops;
    },

    */
  },
  created() {
    this.TRIP_ONE_WAY = 0;
    this.TRIP_ROUNDTRIP = 1;
    this.TRIP_MULTI_CITY = 2;
    this.ARRIVAL_TIME = 1;
    this.DEPARTURE_TIME = 0;
  },
};
